import React, { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { PLATFORM_ORIGIN, hasCustomProfileBackend } from '../utils/customDomain';

const PublicTalentProfile = lazy(() => import('../pages/PublicTalentProfile'));

export default function CustomDomainSite() {
  if (window.location.pathname !== '/' || !hasCustomProfileBackend()) {
    return <main className="min-h-screen bg-black text-white flex flex-col items-center justify-center gap-4 p-6">
      <Helmet><title>Page unavailable</title><meta name="robots" content="noindex" /></Helmet>
      <h1 className="text-xl">This page is unavailable.</h1>
      <a className="underline" href="/">View this profile</a>
      <a className="underline" href={PLATFORM_ORIGIN}>Visit Hutson Talent</a>
    </main>;
  }
  return <Suspense fallback={<div className="min-h-screen bg-black text-white p-8" role="status">Loading profile…</div>}>
    <PublicTalentProfile customHostname={window.location.hostname.toLowerCase()} />
  </Suspense>;
}
